import React from 'react';

import { SvgIcon } from '../../../SvgIcon';

export class QuestionMark extends React.Component {
  render() {
    let style = {};
    if (this.props.isDisabled) {
      style = {
        backgroundColor: 'lightgray',
        filter: 'grayscale(1)',
        opacity: '.7',
        boxShadow: 'none'
      };
    }

    return (
      <div className="attribute-btn" style={style}>
        {this.props.name}{' '}
        <SvgIcon iconPath='/img/icons/set/attributes.svg#question-mark' />
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/snippets/ExplanationAttributes/impl/share/QuestionMark.jsx